module.exports = __webpack_public_path__ + "img/90.6f0883fb.jpg";